<template>
    <div class="home">
       <div class="calc-info" v-if="load.statistics">
		   <el-card class="box-card" shadow="hover">
		     <div slot="header" class="clearfix">
		       <span>客户注册数量</span>
		       <el-button style="float: right; padding: 3px 0" type="text">详情</el-button>
		     </div>
			 <div class="calc-number">{{statistics.user.total}}</div>
			 <div class="cus-number-area">新加坡 {{statistics.user.sg}} 中国内地 {{statistics.user.cn}}</div>
		   </el-card>
		   
		   <el-card class="box-card" shadow="hover">
		     <div slot="header" class="clearfix">
		       <span>运单件数</span>
		       <el-button style="float: right; padding: 3px 0" type="text">详情</el-button>
		     </div>
		   			 <div class="calc-number">{{statistics.order.total}}</div>
		   			 <div class="cus-number-area">新中流向{{statistics.order.totalSg}}件 中新流向{{statistics.order.totalCn}}件</div>
		   </el-card>
         <el-card class="box-card" shadow="hover">
           <div slot="header" class="clearfix">
             <span>待取件数</span>
             <el-button style="float: right; padding: 3px 0" type="text">详情</el-button>
           </div>
           <div class="calc-number">{{statistics.order.pickup}}</div>
           <div class="cus-number-area">新加坡库{{statistics.order.pickupSg}}件 中国库{{statistics.order.pickupCn}}件</div>
         </el-card>

		   
		   <el-card class="box-card" shadow="hover">
		     <div slot="header" class="clearfix">
		       <span>运单已付金额</span>
		       <el-button style="float: right; padding: 3px 0" type="text">详情</el-button>
		     </div>
		   			 <div class="calc-number">{{ statistics.finance.totalPayedExpressPrice }}</div>
		   			 <div class="cus-number-area">运单已付金额（拼团除外）</div>
		   </el-card>
         <el-card class="box-card" shadow="hover">
           <div slot="header" class="clearfix">
             <span>运单待付金额</span>
             <el-button style="float: right; padding: 3px 0" type="text">详情</el-button>
           </div>
           <div class="calc-number">{{ statistics.finance.totalPayingExpressPrice }}</div>
           <div class="cus-number-area">运单待付金额（拼团除外）</div>
         </el-card>

		   
	   </div>

      <div class="calc-info" v-if="load.statistics">
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>充值总额</span>
            <el-button style="float: right; padding: 3px 0" type="text">详情</el-button>
          </div>
          <div class="calc-number">{{ statistics.finance.totalCharge }}</div>
          <div class="cus-number-area">历史客户充值金额</div>
        </el-card>

        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>充值消耗总额</span>
            <el-button style="float: right; padding: 3px 0" type="text">详情</el-button>
          </div>
          <div class="calc-number">{{ statistics.finance.totalExpend }}</div>
          <div class="cus-number-area">历史充值消耗总额</div>
        </el-card>

        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>拼团已收金额</span>
            <el-button style="float: right; padding: 3px 0" type="text">详情</el-button>
          </div>
          <div class="calc-number">{{ statistics.finance.totalGroupPayedPrice }}</div>
          <div class="cus-number-area">历史拼团已收金额</div>
        </el-card>

        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>拼团未收金额</span>
            <el-button style="float: right; padding: 3px 0" type="text">详情</el-button>
          </div>
          <div class="calc-number">{{ statistics.finance.totalGroupPayingPrice }}</div>
          <div class="cus-number-area">历史拼团未收金额</div>
        </el-card>

      </div>
      <div class="calc-info" v-if="load.statistics">
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>今日入库件数</span>

          </div>
          <div class="calc-number">{{ statistics.stockToday.number }}</div>
          <div class="cus-number-area">今日入库完成件数</div>
        </el-card>
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>今日入库重量</span>

          </div>
          <div class="calc-number">{{ statistics.stockToday.weight }} KG</div>
          <div class="cus-number-area">今日入库完成总重量</div>
        </el-card>
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>今日入库体积</span>

          </div>
          <div class="calc-number">{{ statistics.stockToday.volume }} 立方</div>
          <div class="cus-number-area">今日入库完成实际体积</div>
        </el-card>

      </div>
      <div class="calc-info" v-if="load.statistics">
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>入库总件数</span>

          </div>
          <div class="calc-number">{{ statistics.stockTotal.number }}</div>
          <div class="cus-number-area">入库完成件数</div>
        </el-card>
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>入库总重量</span>

          </div>
          <div class="calc-number">{{ statistics.stockTotal.weight }} KG</div>
          <div class="cus-number-area">入库完成总重量</div>
        </el-card>
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>入库总体积</span>

          </div>
          <div class="calc-number">{{ statistics.stockTotal.volume }} 立方</div>
          <div class="cus-number-area">入库完成实际体积</div>
        </el-card>

      </div>
      <div class="calc-info" v-if="load.statistics">
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>入库未转件数</span>

          </div>
          <div class="calc-number">{{ statistics.stockLock.number }}</div>
          <div class="cus-number-area">入库未转件数</div>
        </el-card>
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>入库未转总重量</span>

          </div>
          <div class="calc-number">{{ statistics.stockLock.weight }} KG</div>
          <div class="cus-number-area">入库未转总重量</div>
        </el-card>
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>入库未转总体积</span>

          </div>
          <div class="calc-number">{{ statistics.stockLock.volume }} 立方</div>
          <div class="cus-number-area">入库未转实际体积</div>
        </el-card>

      </div>
	   <div class="order-calendar">
		   <el-calendar v-model="value"/>
	   </div>
    </div>
</template>
<script>
export default {
    data () {
		return {
			value: new Date(),
			load:{
				statistics:false
			},
			statistics:{}
		}
    },
	mounted() {
		this.getStatistics()
	},
    methods: {
     handleSelect(key, keyPath) {
       console.log(key, keyPath);
     },
	 getStatistics(){
		this.$fetch.post('Statistics/getHomePageData',{},true).then(res=>{
			this.load.statistics = true
			this.statistics = res
		}) 
	 }
	 
    }
}
</script>

<style scoped>
	.calc-number{
		font-size: 28px;
		font-weight: 440;
		color: #515a6e;
		padding-bottom: 10px;
	}
	.cus-number-area{
		color: #515a6e;
		font-size: 14px;
	}
	.calc-info{
		display: flex;
		
		padding:0
	}
	.box-card{
		margin:10px;
		flex: 1;
	}
	.order-calendar{
		padding:10px
	}
</style>
